export default __webpack_public_path__ + "static/media/matterkind.27498614.svg";